import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TransportPickupModalService {

  private selectedTransportPickupSubject = new BehaviorSubject<any>(null);
  public selectedTransportPickup$ = this.selectedTransportPickupSubject.asObservable();

  private preSelectedVehicleSubject = new BehaviorSubject<any>(null);
  public preSelectedVehicle$ = this.preSelectedVehicleSubject.asObservable();

  private bulkItemsSubject = new BehaviorSubject<any[]>([]);
  public bulkItems$ = this.bulkItemsSubject.asObservable();

  constructor() { }

  setSelectedTransportPickup(transportPickup: any): void {
    this.selectedTransportPickupSubject.next(transportPickup);
  }

  getSelectedTransportPickup(): any | null {
    return this.selectedTransportPickupSubject.value;
  }

  clearSelectedTransportPickup(): void {
    this.selectedTransportPickupSubject.next(null);
  }

  setPreSelectedVehicle(vehicle: any): void {
    this.preSelectedVehicleSubject.next(vehicle);
  }

  getPreSelectedVehicle(): any | null {
    return this.preSelectedVehicleSubject.value;
  }

  clearPreSelectedVehicle(): void {
    this.preSelectedVehicleSubject.next(null);
  }

  setBulkItems(items: any[]): void {
    this.bulkItemsSubject.next(items);
  }

  getBulkItems(): any[] {
    return this.bulkItemsSubject.value;
  }

  clearBulkItems(): void {
    this.bulkItemsSubject.next([]);
  }
}
